import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  rootActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(4),
  },
  paper: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  rootCard: {
    marginLeft: `${theme.spacing(1)} !important`,
    marginRight: `${theme.spacing(1)} !important`,
  },
  rootContentRow: {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(3, 2),
  },
  btnOptions: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  alertPeopleInsight: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 0),
    backgroundColor: "#e9e7f6",
  },
}));
